import React from "react";
import { Layout } from "components/Layout/Layout";
import { TaskProvider } from "./context";
import { TaskPage } from "./TaskPage";

export const TaskIndex = () => {
  return (
    <TaskProvider>
      <Layout>
        <TaskPage />
      </Layout>
    </TaskProvider>
  );
};
